import { CopyService } from './../../shared/services/copies/copy.service';
import { RequestSolicitationsService } from '../../shared/services/solicitations/request-solicitations.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IRequestSolicitationResponse, ISolicitation } from './../../shared/models/solicitation-models/solicitation/SolicitationModel';
import { ApplicationService } from '../../shared/services/application/application.service';
import { LinkupService } from '../../shared/services/link-up/linkup.service';
import { BaseComponent } from '../../shared/components/base-component';
import { centerDialog, getValueProperty, scrollBottom, scrollTop, setValueProperty } from '../../shared/helpers/functions.helpers';
import { EDocumentTypeId } from '../form-solicitation-basic-data/form-solicitation-basic-data.component';
import { camelCase } from 'lodash';
import { EVENT } from '../../shared/constants/dali.constants';
import { SolicitationModalTypificationComponent } from './../solicitation-modal-typification/solicitation-modal-typification.component';
import { FormSolicitationAdditionalDataComponent } from './../form-solicitation-additional-data/form-solicitation-additional-data.component';
import { FileService } from '../../shared/services/onbase/file-service.service';

export enum EActionModal {
    CANCEL = 'action1',
    OK = 'action2'
}

@Component({
    selector: 'app-solicitation-data',
    templateUrl: './solicitation-data.component.html',
    styleUrls: ['./solicitation-data.component.scss']
})
export class SolicitationDataComponent extends BaseComponent implements OnInit {

    @ViewChild('modalTypification') modalTypificationRef!: SolicitationModalTypificationComponent;
    @ViewChild('formAdditionalData') formAdditionalDataRef!: FormSolicitationAdditionalDataComponent;

    /**
     * Almacena los datos digitados por el cliente en pasos anteriores
     */
    solicitationData: ISolicitation = {};

    /**
     * Contiene los textos y etiquetas
     */
    CONTENT_BOUNDS: any[] | any;

    /**
     * Almacena los pasos del formulario
     */
    stepsList: string[] = [];

    /**
     * Almacena los datos recolectados en el formulario principal
     */
    form: FormGroup = this.fb.group({
        additional_data: this.fb.group({})
    });

    showDialogConfirm = false;
    processResponse: boolean = false;
    ACTION_MODAL = EActionModal;
    private _isLoading = false;
    showErrorMessage = false;

    /**
     *
     * @param _solicitation
     * @param cps
     */
    constructor(
        public _solicitation: RequestSolicitationsService,
        private cps: CopyService,
        public readonly fb: FormBuilder,
        public app: ApplicationService,
        private link: LinkupService,
        private readonly _file: FileService,

    ) {
        super(app, link, "solicitation-data")
    }

    /**
     *
     */
    ngOnInit() {
        this.loadStaticValues().finally(() => {
            super.onLoad();
        });
        this.loadData();
    }

    /**
     * Permite la carga de textos y listas estaticas
     */
    async loadStaticValues() {
        await super.loadStaticValues();
        this.CONTENT_BOUNDS = await this.cps.getCopy("solicitation-data");
        this.stepsList = await this.cps.getCopy("stepList", []);
    }

    /**
     * Permite cargar la información proveniente de los pasos anteriores
     */
    loadData() {
        this.solicitationData = this._solicitation.solicitation;
    }

    /**
     *
     * @param start
     */
    async navigateTo(start: any) {
        this.solicitationData.additionalData = this.additionalDataForm.getRawValue();
        this._solicitation.solicitation = this.solicitationData;
        if (start == "next") {

            let allowRadication = this.getSetting('step', 'submitRadication', false);

            if (allowRadication) {
                this.showDialogConfirm = true;
                centerDialog();
            } else {
                await this._solicitation.navigation.nextStep();
            }

            let word = "";
            if (getValueProperty(this._solicitation, "solicitation.basicData.document_type", "") == EDocumentTypeId.NIT || getValueProperty(this._solicitation, "solicitation.basicData.document_type", "") == EDocumentTypeId.SE) {
                setValueProperty(this.solicitationData, "additionalData.CustomerTypes", "PJ");
                word = "PersonaJuridica";
            }
            else {
                setValueProperty(this.solicitationData, "additionalData.CustomerTypes", "PN");
                word = "PersonaNatural";
            }
            word = camelCase(word);
            word = word[0].toUpperCase() + word.substring(1);
            setValueProperty(this._solicitation, "solicitation.analyticsData.customer_type", word);
            let eventSetting = this.getSetting("analytics", "trackEvent.e2", "");
            let pageSetting = this.getSetting("analytics", "pageLoad", "");
            let events = [
                {
                    "name": "{EVENT.pv4E2setData.pv4E2transactionProductDetails.path}",
                    "value": getValueProperty(this.solicitationData, "analyticsData.customer_type", "")
                },
                {
                    "name": "{EVENT.pv4E2setData.pv4E2clientElegibility.path}",
                    "value": getValueProperty(this.solicitationData, "analyticsData.solicitation_type", "")
                },
                {
                    "name": "{EVENT.pv4E2setData.pv4E2transactionTransactionInstitution.path}",
                    "value": getValueProperty(this.solicitationData, "analyticsData.solicitation_cell", "")
                },
                {
                    "name": "{EVENT.pv4E2setData.pv4E2transactionName.path}",
                    "value": EVENT.pv4E2setData.pv4E2transactionName.value
                },
                {
                    "name": "{EVENT.pv4E2setData.pv4E2transactionProductCategory.path}",
                    "value": getValueProperty(pageSetting, 'transaction.details.productcategory')
                }
            ];
            setValueProperty(eventSetting, "events", events);
            setValueProperty(eventSetting, "messageEvent", getValueProperty(this.solicitationData, "analyticsData.solicitation_subtype", ""));
            word = camelCase(getValueProperty(this.solicitationData, "additionalData.Annotations", ""));
            if (word) {
                word = word[0].toUpperCase() + word.substring(1);
            }
            setValueProperty(eventSetting, "searchTerm", word);
            this.onEvent(eventSetting);
        } else {
            await this._solicitation.navigation.previousStep();
            let eventSetting = this.getSetting("analytics", "trackEvent.e4", "");
            let pageSetting = this.getSetting("analytics", "pageLoad", "");
            let events = [
                {
                    "name": "{EVENT.pv4E4setData.pv4E4transactionName.path}",
                    "value": EVENT.pv4E1setData.pv4E1transactionName.value
                },
                {
                    "name": "{EVENT.pv4E4setData.pv4E4transactionProductCategory.path}",
                    "value": getValueProperty(pageSetting, 'transaction.details.productcategory')
                }
            ];
            setValueProperty(eventSetting, "events", events);
            this.onEvent(eventSetting);
        }
    }

    /**
     * Evento principal de cierre
     * @param $event
     */
    onCloseEvent($event: any) {
        console.log('close event', $event);
    }

    /**
     * Permite obtener la instancia del formulario para la información adicional del cliente
     */
    get additionalDataForm(): FormGroup {
        return this.form.get('additional_data') as FormGroup;
    }

    /**
     * Permite identificar si existe un proceso de carga existente
     */
    get isLoading() {
        const formLoading = getValueProperty(this, 'formAdditionalDataRef.isLoading', true);
        const duplicityLoading = getValueProperty(this, 'formAdditionalDataRef.loader_duplicity', true);
        const modalLoading = getValueProperty(this, 'modalTypificationRef.loading', true);
        const isLoadComponentUpload = getValueProperty(this, 'formAdditionalDataRef.uploadFilesRef', false);
        const uploadFiles = getValueProperty(this, 'formAdditionalDataRef.uploadFilesRef.isLoadingFiles', true);
        return this._isLoading || formLoading || modalLoading || duplicityLoading || (!!isLoadComponentUpload && uploadFiles);
    }

    /**
    * Permite capturar la respuesta del usuario y continuar el proceso segun la acción realizada
    * @param event
    */
    async dialogButtonClicked(event: any) {
        this.showDialogConfirm = false;
        if (event.type === this.ACTION_MODAL.OK) {
            let eventSetting = this.getSetting("analytics", "trackEvent.e3", "");
            let pageSetting = this.getSetting("analytics", "pageLoad", "");
            let events = [
                {
                    "name": "{EVENT.pv5E3setData.pv5E3transactionProductDetails.path}",
                    "value": getValueProperty(this.solicitationData.analyticsData, 'customer_type')
                },
                {
                    "name": "{EVENT.pv5E3setData.pv5E3clientElegibility.path}",
                    "value": getValueProperty(this.solicitationData.analyticsData, 'solicitation_type')
                },
                {
                    "name": "{EVENT.pv5E3setData.pv5E3transactionTransactionInstitution.path}",
                    "value": getValueProperty(this.solicitationData.analyticsData, 'solicitation_cell')
                },
                {
                    "name": "{EVENT.pv5E3setData.pv5E3transactionName.path}",
                    "value": EVENT.pv5E3setData.pv5E3transactionName.value
                },
                {
                    "name": "{EVENT.pv5E3setData.pv5E3transactionProductCategory.path}",
                    "value": getValueProperty(pageSetting, 'transaction.details.productcategory')
                }
            ];
            setValueProperty(eventSetting, "events", events);
            setValueProperty(eventSetting, "messageEvent", getValueProperty(this.solicitationData.analyticsData, 'solicitation_subtype'));
            let word = camelCase(getValueProperty(this.solicitationData, "additionalData.Annotations", ""));
            if (word) {
                word = word[0].toUpperCase() + word.substring(1);
            }
            setValueProperty(eventSetting, "searchTerm", word);
            this.onEvent(eventSetting);

            this._isLoading = true;
            const documentNumber = getValueProperty(this.solicitationData.basicData, 'document_number', '');
            const documentType = getValueProperty(this.solicitationData.basicData, 'document_type', '');
            const buildData = await this._solicitation.buildData(this.solicitationData);
            const responseRequest = await this._solicitation.send(buildData, documentType, documentNumber);

            if (responseRequest.hasOwnProperty('data') && getValueProperty(responseRequest, 'data.solicitation.solicitation_id', false)) {
                const isProcessDocuments = await this.processDocuments(responseRequest as IRequestSolicitationResponse);
                setValueProperty(this._solicitation.solicitation, "additionalData.errorUpload", !isProcessDocuments);
                this._solicitation.navigation.nextStep();
            }
            else {
                let eventSetting = this.getSetting("analytics", "trackEvent.e5", "");
                let pageSetting = this.getSetting("analytics", "pageLoad", "");
                let events = [
                    {
                        "name": "{EVENT.pv5E5setData.pv5E5transactionName.path}",
                        "value": EVENT.pv5E5setData.pv5E5transactionName.value
                    },
                    {
                        "name": "{EVENT.pv5E5setData.pv5E5transactionProductCategory.path}",
                        "value": getValueProperty(pageSetting, 'transaction.details.productcategory')
                    }
                ];
                setValueProperty(eventSetting, "events", events);
                setValueProperty(eventSetting, "messageEvent", getValueProperty(responseRequest, "numberTrys", 1));
                let word = camelCase(getValueProperty(responseRequest, "message", ""));
                word = word[0].toUpperCase() + word.substring(1);
                setValueProperty(eventSetting, "errorName", getValueProperty(responseRequest, "code", "NO_RESPONSE") + " | " + word);
                this.onEvent(eventSetting);
            }
            this._isLoading = false;
            this.showErrorMessage = true;
            scrollTop();
        }
        else if (event.type === this.ACTION_MODAL.CANCEL) {
            let eventSetting = this.getSetting("analytics", "trackEvent.e4", "");
            let pageSetting = this.getSetting("analytics", "pageLoad", "");
            let events = [
                {
                    "name": "{EVENT.pv5E4setData.pv5E4transactionName.path}",
                    "value": EVENT.pv5E4setData.pv5E4transactionName.value
                },
                {
                    "name": "{EVENT.pv5E4setData.pv5E4transactionProductCategory.path}",
                    "value": getValueProperty(pageSetting, 'transaction.details.productcategory')
                }
            ];
            setValueProperty(eventSetting, "events", events);
            this.onEvent(eventSetting);
            scrollBottom();
        }

        

    }

    /**
     * @todo Implementar funcionalidad
     * @param responseRequest
     */
    async processDocuments(responseRequest: IRequestSolicitationResponse): Promise<boolean> {
        /**
         * @todo Validar cuando no se cargan soportes, debe permitir la radicación
         **/
        this.processResponse = true;
        try {
            /**
             *  Incluir logica de cargue documetal
             */
            if (getValueProperty(responseRequest, 'data.solicitation.solicitation_id', false)) {
                const fileData = await this._file.buildData(this._solicitation.solicitation);
                await this._file.send(fileData);
            }
            else {
                throw "ERR PQR"
            }
        }
        catch (error) {
            this.processResponse = false;
        }
        return this.processResponse;
    }

}
